import { useQuery } from '@tanstack/react-query';
import { api, type AppStatus, type Ich } from './client';
import { useAuth } from '../lib/auth';

// Alles Nutzerbezogene haengt an der Nutzer-ID im Schluessel, damit nach einem Personenwechsel
// nie Daten der vorherigen Person aus dem Cache erscheinen.
export const schluessel = {
  ich: (nutzerId: string) => ['nutzer', nutzerId, 'ich'] as const,
  status: ['status'] as const,
};

export function useIch() {
  const { zustand } = useAuth();
  const nutzerId = zustand.status === 'angemeldet' ? zustand.session.user.id : 'abgemeldet';
  return useQuery({
    queryKey: schluessel.ich(nutzerId),
    queryFn: () => api<Ich>('/ich'),
    enabled: zustand.status === 'angemeldet',
    staleTime: 5 * 60_000,
  });
}

export function useAppStatus() {
  return useQuery({
    queryKey: schluessel.status,
    queryFn: () => api<AppStatus>('/status'),
    staleTime: 10 * 60_000,
  });
}
